export default class FreespinModel {
  constructor() {
    this._data = {
      add: 0,
      all: 0,
      left: 0,
      totalWin: 0,
      multiplier: 0,
      expendingSymbol: '',
      stickySymbol: '',
      stickyPosition: [],
      stickyPrevPosition: [],
    }
  }

  get() {
    return this._data
  }

  checkCascadeBonusGame(value){
    if (value.components && value.components.length > 0) {

      this.parseComponents(value.components)
    }
  }

  parseComponents(components){
    components.forEach((component) => {

      if (component.freespins) {
        this._data.add = component.freespins.count.add
        this._data.all = component.freespins.count.total
        this._data.left = component.freespins.count.rest
        this._data.multiplier = component.freespins.count.collectible || 0
        this._data.totalWin = component.freespins.win
      }
    })
  }

  set(value) {

    if (value.freespins) {
      this._data.add = value.freespins.count.add
      this._data.all = value.freespins.count.total
      this._data.left = value.freespins.count.rest
      this._data.multiplier = value.freespins.count.collectible || 0
      this._data.totalWin = value.freespins.win
      if(value.freespins.expendingSymbol){
        this._data.expendingSymbol = value.freespins.expendingSymbol
      }
      else{
        this._data.expendingSymbol = value.freespins.count.expandingSymbols ? value.freespins.count.expandingSymbols[0] : ''
      }
      if(value.features){
        value.features.forEach((features) => {
          switch (features.type) {
            case 'expandingSymbol':
              this._data.expendingSymbol = features.symbol
              break
            case 'sticky':
              this._data.stickySymbol = features.symbol
              this._data.stickyPosition  = features.positions
              break
          }
        })
      }
    }
    else {
      this._data.add = 0
      this._data.all = 0
      this._data.left = 0
      this._data.totalWin = 0
      this._data.expendingSymbol = ''
      this._data.stickySymbol = ''
      this._data.stickyPosition = []
    }

    if(game.models.CascadeModel.get().isCascade){
      this.checkCascadeBonusGame(value)
    }
  }
}
